<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 15:51:42
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 15:03:37
 * @Description: 生成月报价-信息价期数
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\dialog\informationPriceNumDialog.vue
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="infoNumDialog" width="1300px" :append-to-body="true" :close-on-click-modal="false" :before-close="close" @open="openMethod">
      <span slot="title" class="dialog-title">生成期数</span>
      <div style="margin: 15px 25px">
        <el-button size="mini" class="bottom_one" :disabled="dialogData.length > 0 && dialogData[0].status == 0" @click="updateInformationPerid">更新数据</el-button>
        <div style="margin-right: 20px; display: flex; align-items: center; justify-content: end">
          <span>历史版本:</span>
          <el-select v-model="historyName" placeholder="请选择">
            <el-option v-for="item in historyList" :key="item.time" :label="item.time" :value="item.time" @click.native="selectHistory(item)"> </el-option>
          </el-select>
        </div>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="dialogData" tooltip-effect="dark">
        <template v-for="(item, index2) in table">
          <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.label == '状态'" class="table_link">
                {{ mouthReportStatusList | fromatTable(scope.row.sureStatus, "name", "id") }}
              </span>
              <!-- <div v-else-if="item.label == '信息价期数'">
                <span>{{ scope.row.period == "无" ? "未维护" : scope.row.period }}</span>
              </div> -->
              <div v-else-if="item.label == '操作'">
                <div v-if="scope.row.status == 1">
                  <el-button v-if="scope.row.sureStatus == 0" size="mini" class="bottom_one" @click="setMonthPrice(scope.row, false, scope.row.sureStatus, scope.$index)">{{
                    showType == 2 ? "生成月报价" : "生成结算价"
                  }}</el-button>
                  <el-button v-else size="mini" class="bottom_one" @click="setMonthPrice(scope.row, scope.row.sureStatus, false)">查看</el-button>
                </div>
                <div v-else>
                  <el-button key="see" size="mini" class="bottom_one" :disabled="scope.row.sureStatus == 0" @click="setMonthPrice(scope.row, true)">查看</el-button>
                </div>
              </div>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="close()">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div v-for="(item, index) in titleData" :key="index">
        <span>{{ item }}</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <monthPriceDialog
      ref="monthPriceDialog"
      :monthPriceDialog.sync="monthPriceDialog"
      :showType.sync="showType"
      :isLook.sync="isLook"
      :monthPriceData.sync="monthPriceData"
      :priceInfo.sync="priceInfo"
      :monthPriceType="2"
      :adjustPriceType="infoNumData.adjustPriceType"
      @closeMonthPriceDialog="(monthPriceDialog = false), queryHisttoryPeriodList()"
    >
    </monthPriceDialog>
    <unmaintainedDialog
      :unmaintainedDialog.sync="unmaintainedDialog"
      :contractId="infoNumData.contractId"
      :showType="showType"
      :monthPriceType="2"
      :data="monthPriceData"
      @closeUnmaintainedDialog="(unmaintainedDialog = false), queryHisttoryPeriodList()"
    />
  </div>
</template>

<script>
import { queryHisttoryPeriodList, updateInformationPerid,queryWaitUpdateInformationPrice } from "@/api/wise/Wise_contactsbusiness/contactPriceList.js";
import monthPriceDialog from "./monthPriceDialog.vue";
import unmaintainedDialog from "./unmaintainedDialog.vue";
export default {
  components: {
    monthPriceDialog,
    unmaintainedDialog,
  },
  props: {
    infoNumDialog: {
      type: Boolean,
      default: false,
    },
    // infoNumData: {
    //     type: String,
    //     default: '',
    // },
    infoNumData: {
      type: Object,
      default: () => {},
    },
    priceInfo: {
      type: Object,
      default: () => {},
    },
    showType: {
      type: Number,
      default: 1,
    },
    // contractId: {
    //     type: String,
    //     default: '',
    // },
  },
  data() {
    return {
      monthPriceData: {},
      monthPriceDialog: false,
      unmaintainedDialog: false,
      table: [
        { label: "开始时间", width: "", prop: "startTime", status: true },
        { label: "结束时间", width: "", prop: "endTime", status: true },
        { label: "期数", width: "", prop: "period", status: true },
        { label: "状态", width: "", prop: "sureStatus", status: true },
        { label: "操作", width: "", prop: "", status: true },
      ],
      dialogData: [],
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
      ],
      files: [],
      areaList: "",
      historyList: [],
      historyName: "",
      isLook: false,
      titleData: [],
      dialogVisible: false,
      sureStatus: 0,
    };
  },
  created() {},
  methods: {
    selectHistory(item) {
      this.dialogData = item.periods;
      this.historyName = item.time;
    },
    updateInformationPerid() {
      this.$confirm("是否确认更新?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updateInformationPerid({ priceManageId: this.infoNumData.id }).then(res => {
            if (res.code == 1001) {
              this.$message.success("更新成功!");
              this.queryHisttoryPeriodList();
            }
          });
        })
        .catch(() => {});
    },
    openMethod() {
      this.queryHisttoryPeriodList();
    },
    queryHisttoryPeriodList() {
      queryHisttoryPeriodList({ priceManageId: this.infoNumData.id }).then(res => {
        if (res.code == 1001) {
          let resData = [];
          let keyArr = Object.keys(res.data).sort(function (a, b) {
            return b < a ? -1 : 1;
          });
          console.log(keyArr);
          keyArr.forEach((item, index) => {
            resData.push({
              time: item + (index == 0 ? "(最新)" : ""),
              periods: res.data[item],
              adjustmentPriceManages: null,
            });
          });
          this.historyList = resData;
          this.dialogData = resData[0].periods;
          this.historyName = resData[0].time;
        }
      });
    },
    close() {
      this.$emit("closeInformationSetPriceDialog", false);
    },
    setMonthPrice(row, isLook, sureStatus, index) {
      this.sureStatus = sureStatus;
      if (index || index == 0) {
        let status = false; //判断是否可以去确认
        if (index == this.dialogData.length - 1) {
          status = true;
        } else {
          status = this.dialogData[index + 1].sureStatus == 0 ? false : true;
        }
        this.dialogData.forEach((item, index2) => {
          if (index2 > index && item.sureStatus == 0) {
            status = false;
          }
        });
        if (!status) {
          this.$message.warning("请按照时间先后顺序进行确认！");
          return;
        }
      }
      queryWaitUpdateInformationPrice({ dataId: this.infoNumData.id }).then(res => {
        if (res.code == 1001) {
          if (res.data.length > 0) {
            this.titleData = res.data;
            this.dialogVisible = true;
          } else {
            this.isLook = isLook;
            this.monthPriceData = row;
            if (row.adjustPriceType == 5) {
              this.unmaintainedDialog = true;
            } else {
              this.monthPriceDialog = true;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.popperClass.el-date-picker {
  width: 220px;
}
</style>